export default "__VITE_ASSET__B9T2$f3g__"